import React, { useState } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import PackageImage from '../../../../../../generic/assets/package.png';
import PackageSelector from '../../../../../../generic/ui/Selectors/PackageSelector';
import { FormShell, FormField, FormFooter } from '../../../../../../generic/ui/FormLayout';
import IconTextField from '../../../../../../generic/ui/Input/IconTextField';
import { AccentButton } from '../../../../../../generic/ui/Button';
import selectOnFocus from '../../../../../../modules/autoselect';
import { IPackagesItem } from '../../../../../../modules/API/Defaults/models/packages';

interface Props {
    list: IPackagesItem[];
    defaultID: number;
    saveFunc: (qty: number, packID: number) => void;
    closeFunc?: (flag?: boolean) => void;
}

const ModalArizot: React.FC<Props> = ({ list, defaultID, saveFunc, closeFunc }) => {
    const [t] = useTranslation(['likut', 'buttons']);
    const [selectedPack, setSelectedPack] = useState<IPackagesItem | null>(
        list?.find((p) => p.PackID === defaultID) ?? null
    );
    const [qty, setQty] = useState(0);

    const handleSave = () => {
        saveFunc(qty, selectedPack?.PackID ?? 0);
        closeFunc?.();
    };

    return (
        <FormShell>
            <TitleImg src={PackageImage} alt='package' />
            <FormField label={t('likut_modal_addpackage_title')} fullWidth>
                <PackageSelector
                    packages={list ?? []}
                    value={selectedPack}
                    onSelect={setSelectedPack}
                />
            </FormField>
            <FormField label={t('likut_sectionmain_pallet_product_qty')} fullWidth>
                <QtyRow>
                    <QtyBtn type='button' onClick={() => setQty((v) => Math.max(0, v - 1))} aria-label='-'>
                        −
                    </QtyBtn>
                    <IconTextField
                        type='number'
                        value={qty}
                        onChange={(e) => setQty(Number(e.target.value))}
                        onClick={selectOnFocus}
                    />
                    <QtyBtn type='button' onClick={() => setQty((v) => v + 1)} aria-label='+'>
                        +
                    </QtyBtn>
                </QtyRow>
            </FormField>
            <FormFooter>
                <AccentButton type='button' onClick={handleSave} fullWidth={false}>
                    {t('save', { ns: 'buttons' })}
                </AccentButton>
            </FormFooter>
        </FormShell>
    );
};

export default ModalArizot;

const TitleImg = styled.img`
    width: 100%;
    max-width: 220px;
    align-self: center;
`;

const QtyRow = styled.div`
    display: flex;
    align-items: center;
    gap: 0.5rem;
    direction: ltr;
`;

const QtyBtn = styled.button`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 2.875rem;
    height: 2.875rem;
    flex-shrink: 0;
    border-radius: 0.875rem;
    border: 1px solid ${({ theme }) => theme.colors.inputBorder};
    background: ${({ theme }) => theme.colors.surface};
    color: ${({ theme }) => theme.colors.ink};
    font-size: ${({ theme }) => theme.text.xl};
    cursor: pointer;
    transition: all ${({ theme }) => theme.motion.fast} ease;

    &:hover {
        border-color: ${({ theme }) => theme.colors.inputBorderHover};
        background: ${({ theme }) => theme.colors.accentSoft};
    }

    &:active {
        transform: translateY(1px);
    }
`;
